import React from 'react';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { AppBar, Toolbar, ThemeProvider } from '@mui/material';

import PoweredByLinks from 'app/fuse-layouts/shared-components/PoweredByLinks';
import PurchaseButton from 'app/fuse-layouts/shared-components/PurchaseButton';
import DocumentationButton from 'app/fuse-layouts/shared-components/DocumentationButton';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';

function FooterLayout1({ className }: { className?: string }) {
	const footerTheme = useSelector(selectFooterTheme);

	return (
		<ThemeProvider theme={footerTheme}>
			<AppBar
				id="fuse-footer"
				className={clsx('relative z-20 shadow-md', className)}
				color="default"
				sx={{ backgroundColor: footerTheme.palette.background.paper }}
			>
				<Toolbar className="flex min-h-48 items-center overflow-x-auto px-8 py-0 sm:px-12 md:min-h-64">
					<div className="flex shrink-0 flex-grow">
						<PurchaseButton className="mx-4" />
						<DocumentationButton className="mx-4" />
					</div>

					<div className="flex shrink-0 flex-grow justify-end px-12">
						<PoweredByLinks />
					</div>
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

export default React.memo(FooterLayout1);
